var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignedStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 7.16675C4.92927 7.16675 5.18934 7.11502 5.43199 7.01451C5.67464 6.914 5.89512 6.76668 6.08084 6.58096C6.26656 6.39524 6.41388 6.17477 6.51439 5.93212C6.61489 5.68946 6.66663 5.42939 6.66663 5.16675C6.66663 4.9041 6.61489 4.64403 6.51439 4.40138C6.41388 4.15873 6.26656 3.93825 6.08084 3.75253C5.89512 3.56682 5.67464 3.4195 5.43199 3.31899C5.18934 3.21848 4.92927 3.16675 4.66663 3.16675C4.13619 3.16675 3.62749 3.37746 3.25241 3.75253C2.87734 4.12761 2.66663 4.63632 2.66663 5.16675C2.66663 5.69718 2.87734 6.20589 3.25241 6.58096C3.62749 6.95603 4.13619 7.16675 4.66663 7.16675ZM4.66663 7.16675V13.8334M4.66663 7.16675C4.66663 8.72208 5.59996 11.8334 9.33329 11.8334",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13.8335C12.4378 13.8335 13.3333 12.9381 13.3333 11.8335C13.3333 10.7289 12.4378 9.8335 11.3333 9.8335C10.2287 9.8335 9.33325 10.7289 9.33325 11.8335C9.33325 12.9381 10.2287 13.8335 11.3333 13.8335Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignedStatus);
export default __webpack_public_path__ + "static/media/assigned-status.a03347295d1196014115f13de7b82332.svg";
export { ForwardRef as ReactComponent };